import React from 'react'
import { getCatalogProductImageUrl } from '../../../api/marketing/gifts/giftFundHelpers'
import styles from './BlogArticle.module.scss'

const formatPrice = (price) => {
  if (price == null || price === '') return null
  const num = Number(price)
  if (!Number.isFinite(num)) return null
  return `${num.toLocaleString('uk-UA')} ₴`
}

/**
 * Lightweight product tiles for article / BO preview (not full storefront cards).
 * Expects productRefs enriched with name, avatarFileName, price when available.
 */
function BlogProductSetTiles({ title = '', productRefs = [] }) {
  const refs = Array.isArray(productRefs) ? productRefs : []
  const titleText = typeof title === 'string' ? title.trim() : ''
  if (!refs.length && !titleText) return null

  return (
    <div className={styles.productSet}>
      {titleText ? <h3 className={styles.productSetTitle}>{titleText}</h3> : null}
      {refs.length ? (
        <div className={styles.productGrid}>
          {refs.map((ref) => {
            const catalog = ref.catalog === 'outlet' ? 'outlet' : 'premium'
            const imageUrl = getCatalogProductImageUrl({
              productId: ref.productId,
              fileName: ref.avatarFileName,
              catalogSource: catalog,
            })
            const priceLabel = formatPrice(ref.price)
            const remain =
              ref.remainQuantity != null && Number.isFinite(Number(ref.remainQuantity))
                ? Number(ref.remainQuantity)
                : null
            return (
              <div key={`${catalog}:${ref.productId}`} className={styles.productTile}>
                <div className={styles.productTileMedia}>
                  {imageUrl ? (
                    <img src={imageUrl} alt={ref.name || ''} loading="lazy" />
                  ) : (
                    <div className={styles.productTilePlaceholder} aria-hidden="true" />
                  )}
                </div>
                <div className={styles.productTileBody}>
                  {ref.brandName ? <p className={styles.productTileBrand}>{ref.brandName}</p> : null}
                  <p className={styles.productTileName}>{ref.name || ref.productId}</p>
                  {ref.descriptionShort ? (
                    <p className={styles.productTileDesc}>{ref.descriptionShort}</p>
                  ) : null}
                  <div className={styles.productTileFooter}>
                    {priceLabel ? <span className={styles.productTilePrice}>{priceLabel}</span> : <span />}
                    <span className={styles.productTileCatalog}>
                      {catalog === 'outlet' ? 'Outlet' : 'Premium'}
                    </span>
                  </div>
                  {remain != null ? (
                    <p
                      className={`${styles.productTileRemain} ${
                        remain <= 0 ? styles.productTileRemainEmpty : ''
                      }`.trim()}
                    >
                      Залишок на сайті: {remain}
                    </p>
                  ) : null}
                </div>
              </div>
            )
          })}
        </div>
      ) : null}
    </div>
  )
}

export default BlogProductSetTiles
